import { render, staticRenderFns } from "./AttributionLayer.vue?vue&type=template&id=dfde5f3c&scoped=true&"
import script from "./AttributionLayer.vue?vue&type=script&lang=js&"
export * from "./AttributionLayer.vue?vue&type=script&lang=js&"
import style0 from "./AttributionLayer.vue?vue&type=style&index=0&id=dfde5f3c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfde5f3c",
  null
  
)

export default component.exports